import { render } from "./DefaultInput.vue?vue&type=template&id=60e35a42&scoped=true"
import script from "./DefaultInput.vue?vue&type=script&lang=js"
export * from "./DefaultInput.vue?vue&type=script&lang=js"

import "./DefaultInput.vue?vue&type=style&index=0&id=60e35a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e35a42"]])

export default __exports__